// @ts-check
import { isNo, isYes } from '../constants/answers'

/** @param {Record<string, any>} self */
const hasNoIncome = self =>
	Object.values(self).every(cat => {
		if (cat && typeof cat === 'object' && 'has' in cat) return isNo(cat.has)
		return true
	})

/** @param {import('../types/formData').FormData | undefined} formData */
export const getRequiredDocs = formData => {
	const secB = formData?.sectionB || {}
	const secC = formData?.sectionC || {}
	const secD = formData?.sectionD || {}
	const secE = formData?.sectionE || {}
	const secG = formData?.sectionG || {}
	const secH = formData?.sectionH || {}
	const secI = formData?.sectionI || {}
	const secJ = formData?.sectionJ || {}

	const isSGBXII = isYes(secE.receivesSocialAssistanceSGBXII)
	const self = secE.self || {}
	const partner = secE.partner || {}
	const hasPartner = isYes(secE.hasPartner)

	const rules = [
		{ when: isYes(secB.hasInsurance), ids: ['insurance_policy'] },
		{ when: isYes(secC.hasMaintenanceClaims), ids: ['maintenance_claims'] },
		{ when: isYes(secD.hasDependents), ids: ['dependents_proof'] },
	]

	if (isSGBXII) {
		rules.push({ when: true, ids: ['sgb12'] })
		return rules.filter(r => r.when).flatMap(r => r.ids.map(id => ({ id })))
	}

	rules.push(
		{ when: isYes(self.nichtselbstaendig?.has), ids: ['salary_self'] },
		{ when: isYes(self.selbstaendig?.has), ids: ['tax_self'] },
		{ when: isYes(self.arbeitslosengeld?.has) || isYes(self.buergergeld?.has), ids: ['alg_self'] },
		{ when: isYes(self.rente?.has), ids: ['pension_self'] },
		{ when: hasPartner && isYes(partner.nichtselbstaendig?.has), ids: ['salary_partner'] },
		{
			when: hasPartner && (isYes(partner.selbstaendig?.has) || isYes(partner.rente?.has)),
			ids: ['income_partner'],
		},
		{ when: hasNoIncome(self), ids: ['e5_explain'] },
		{ when: true, ids: ['bank_statements'] },
		{ when: isYes(secG.realEstate?.has), ids: ['real_estate'] },
		{ when: isYes(secG.vehicles?.has), ids: ['vehicle_doc'] },
		{ when: isYes(secG.lifeInsurance?.has), ids: ['life_insurance'] },
		{ when: secH.housingType === 'tenant', ids: ['rent_contract', 'heating_bill'] },
		{ when: secH.housingType === 'owner', ids: ['loan_home', 'housing_costs'] },
		{ when: isYes(secI.hasObligations), ids: ['loans_general'] },
		{ when: isYes(secJ.hasSpecialLoads), ids: ['special_loads'] }
	)

	return rules.filter(r => r.when).flatMap(r => r.ids.map(id => ({ id })))
}
